import { Map, AnyPaint, AnyLayout, Expression } from 'mapbox-gl';
import { isEqual } from 'lodash-es';

export const updateLayout = <T extends AnyLayout>(
  map: Map,
  id: string,
  layout?: T,
  prevLayout?: T
) => {
  if (layout === prevLayout) return;

  // Update any layout properties that changed
  for (const key in layout) {
    if (!isEqual(layout[key], prevLayout?.[key])) {
      map.setLayoutProperty(id, key, layout[key]);
    }
  }
  // Make sure to reset any layout properties if they were removed
  for (const key in prevLayout) {
    if (layout && !layout.hasOwnProperty(key)) {
      map.setLayoutProperty(id, key, null);
    }
  }
};

export const updatePaint = <T extends AnyPaint>(
  map: Map,
  id: string,
  paint?: T,
  prevPaint?: T
) => {
  if (paint === prevPaint) return;

  // Update any paint properties that changed
  for (const key in paint) {
    if (!isEqual(paint[key], prevPaint?.[key])) {
      map.setPaintProperty(id, key, paint[key]);
    }
  }
  // Make sure to reset any paint properties if they were removed
  for (const key in prevPaint) {
    if (paint && !paint.hasOwnProperty(key)) {
      map.setPaintProperty(id, key, null);
    }
  }
};

export const updateFilter = <T extends Expression>(
  map: Map,
  id: string,
  filter?: T,
  prevFilter?: T
) => {
  if (!isEqual(filter, prevFilter)) {
    map.setFilter(id, filter);
  }
};

export const updateBeforeId = <T extends string>(
  map: Map,
  id: string,
  beforeId?: T,
  prevBeforeId?: T
) => {
  if (beforeId !== prevBeforeId && map.getLayer(id)) {
    map.moveLayer(id, beforeId);
  }
};
